import { IGridColumn } from 'components/common/Grid/types';
import { ILiftTicketData } from 'components/region/LiftTicketTable/types';
import { Routes } from 'routes';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import ToExternalPurchasePageButton from 'components/region/LiftTicketTable/components/ToExternalPurchasePageButton';
import TitleCell from 'components/common/Grid/Cells/TitleCell';

import gridStyles from 'components/common/Grid/styles.module.scss';
import cellStyles from 'components/common/Grid/Cells/styles.module.scss';
import styles from './styles.module.scss';

export const getTableColumns = (hasAllPricesInOneCurrency: boolean): Array<IGridColumn> => {
  const { t } = useOTSTranslation('common');

  return [{
    header: {
      cellRender: () => (<span>{t('region.liftTickets.resort')}</span>),
      columnName: t('region.liftTickets.resort'),
      isSortable: true,
      className: gridStyles.firstColumn,
    },
    dataKey: 'title',
    cellRender: (data: ILiftTicketData) => (
      <TitleCell
        title={data.resort.title}
        href={Routes.resortLiftTickets(data.resort)}
        className={styles.titleCell}
      >
        {!hasAllPricesInOneCurrency && (
          <span className={cellStyles.small}>{`${t('region.liftTickets.currencyText')} ${data.currency}`}</span>
        )}
      </TitleCell>
    ),
  }, {
    header: {
      columnName: `${t('region.liftTickets.season')} ${t('resort.liftTickets.adult')}`,
      isSortable: true,
    },
    dataKey: 'seasonPassAdult',
  }, {
    header: {
      columnName: `${t('region.liftTickets.season')} ${t('resort.liftTickets.child')}`,
      isSortable: true,
    },
    dataKey: 'seasonPassChild',
  }, {
    header: {
      columnName: `${t('resort.liftTickets.weekday')} ${t('resort.liftTickets.adult')}`,
      isSortable: true,
    },
    dataKey: 'dailyPassAdult',
  }, {
    header: {
      columnName: `${t('resort.liftTickets.weekday')} ${t('resort.liftTickets.child')}`,
      isSortable: true,
    },
    dataKey: 'dailyPassChild',
  }, {
    header: {
      cellRender: () => <>{t('common.purchase')}</>,
      className: gridStyles.transparentCell,
    },
    dataKey: 'purchaseUrl',
    className: styles.buttonCell,
    cellRender: (data: ILiftTicketData) => <ToExternalPurchasePageButton url={data.purchaseUrl} resort={data.resort} />,
  }];
};
